'use client';

import { useTranslations } from 'next-intl';
import { Icon } from '@/components/ui/icon';
import { CookbookPicker } from './cookbook-picker';
import type { VariantType } from '@/db/schema/enums';
import styles from './recipe-card.module.css';

interface RecipeCardActionsProps {
  recipeId: string;
  variantType: VariantType;
}

/**
 * The card's single quiet action: a Save-to-cookbook bookmark floated over the
 * recipe image. Per the #302 lean card, the card carries only Save — Plan (add
 * to meal plan) lives on the recipe detail page. Rendered as a sibling of the
 * card link (never nested inside the <a>) so the click stays isolated.
 */
export function RecipeCardActions({ recipeId, variantType }: RecipeCardActionsProps) {
  const t = useTranslations('recipes');

  return (
    <CookbookPicker
      recipeId={recipeId}
      variantType={variantType}
      align="end"
      triggerClassName={styles.saveFloat}
      triggerLabel={t('saveToCookbook')}
    >
      <Icon name="bookmark" size={18} strokeWidth={1.75} aria-hidden="true" />
    </CookbookPicker>
  );
}
